import debounce from "lodash/debounce";
/**
 * @hidden
 */
const reset = "border:0px;padding:0px;";
/**
 * @hidden
 */
const hidden = "clip:rect(0px,0px,0px,0px);height:1px;margin-bottom:-1px;margin-right:-1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px";
/**
 * @hidden
 */
const update = (e, id) => {
    e.id = id;
    e.setAttribute("role", "status");
    e.setAttribute("aria-live", "polite");
    e.setAttribute("aria-atomic", "true");
    return e;
};
/**
 * Generates a screen reader compatible live area for announcements
 *
 * @hidden
 */
export const announcer = ({ document, idA, idB }) => {
    const container = document.createElement("div");
    container.setAttribute("style", reset + hidden);
    const a = update(document.createElement("div"), idA);
    const b = update(document.createElement("div"), idB);
    container.appendChild(a);
    container.appendChild(b);
    let A = true;
    const announce = debounce((message) => {
        const announcer = A ? a : b;
        const backup = A ? b : a;
        A = !A;
        announcer.textContent = message;
        backup.textContent = "";
    }, 1500, {});
    return { container, announce };
};
